import script from "./TournamentServicesAndSports.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentServicesAndSports.vue?vue&type=script&setup=true&lang=js"

import "./TournamentServicesAndSports.vue?vue&type=style&index=0&id=55dcfbd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dcfbd0"]])

export default __exports__